import { CardType } from "../../../util/enums";
import MentalDeck from "../../../assets/cards/mental_deck.svg";
import EmotionalDeck from "../../../assets/cards/emotional_deck.svg";
import SocialDeck from "../../../assets/cards/social_deck.svg";
import PhysicalDeck from "../../../assets/cards/physical_deck.svg";
import { useSound } from "../../../hooks";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { BoardContext, SocketContext, TableContext, TeamContext } from "../../../context";
import { useTranslation } from "react-i18next";

interface IClickedDeckStyle {
    emotional: string;
    social: string;
    mental: string;
    physical: string;
}

const InitialDeck = () => {
    const { t } = useTranslation();
    const { 
        setIsEmotionalCardVisible, 
        setIsSocialCardVisible, 
        setIsMentalCardVisible, 
        setIsPhysicalCardVisible, 
        isUpdatingStatesDisabled, 
        setIsUpdatingStatesDisabled,
        setAreAnimatedHandsShown,
        isEmotionalCardVisible,
        isSocialCardVisible,
        isMentalCardVisible,
        isPhysicalCardVisible
    } = useContext(TableContext);
    const { socket } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { setIsInitialSolutionDecksModalOpen, setAreSolutionCardsDrawnContext } = useContext(BoardContext);
    const {playSound} = useSound();
    let [clickedDeckStyle, setClickedDeckStyle] = useState<IClickedDeckStyle>({
        emotional: "",
        social: "",
        mental: "",
        physical: ""
    })
    const numberOfDrawnCard = useRef<number>(0);
    const numberOfDecks: number = 4;

    const initialiseIsInitialSolutionDecksModalOpen = useCallback(() => {
        let players = game?.gameInfo.players;
        let counter: number = 0;
        let nubmerOfPlayers : number = game?.players.length || 0;

        for(const email in players){
            if(players[email]?.hasDrawnSolutionCards)
                counter = counter + 1;
        }

        if(counter === nubmerOfPlayers)
            setIsInitialSolutionDecksModalOpen(false);
    }, [game?.gameInfo.players, game?.players.length, setIsInitialSolutionDecksModalOpen])

    useEffect(() => {
        initialiseIsInitialSolutionDecksModalOpen();
    }, [initialiseIsInitialSolutionDecksModalOpen]);

    const setAreSolutionCardsDrawn = () => {
        socket?.emit("setAreSolutionCardsDrawn", { areSolutionCardsDrawn: true });
    }

    const drawSolutionCardFromDeckLogic = (cardType: CardType) => {
        drawSolutionCardFromDeck(cardType);
        
        emitSocketWhenAllSolutionCardsAreDrawn();
    }

    const emitSocketWhenAllSolutionCardsAreDrawn = () => {
        numberOfDrawnCard.current = numberOfDrawnCard.current + 1;

        if (numberOfDrawnCard.current === 1) {
            setAreAnimatedHandsShown(true);
            return;
        }

        if (numberOfDrawnCard.current === numberOfDecks){
            setAreSolutionCardsDrawn();
            setAreSolutionCardsDrawnContext(true);
        }
    }

    const emotionalRef = useRef<any>(null);
    const socialRef = useRef<any>(null);
    const mentalRef = useRef<any>(null);
    const physicalRef = useRef<any>(null);

    useEffect(() => {
        const timeout = setTimeout( () => {
            if (emotionalRef.current && isEmotionalCardVisible)
                emotionalRef.current.click();
        }, 1300);

        return () => clearTimeout(timeout);
    }, [isEmotionalCardVisible]);
    
    useEffect(() => {
        const timeout = setTimeout( () => {
            if (socialRef.current  && isSocialCardVisible)
                socialRef.current.click();
        }, 2600);

        return () => clearTimeout(timeout);
    }, [isSocialCardVisible]);

    useEffect(() => {
        const timeout = setTimeout( () => {                
            if (mentalRef.current  && isMentalCardVisible)
                mentalRef.current.click();
        }, 3900);

        return () => clearTimeout(timeout);
    }, [isMentalCardVisible]);

    useEffect(() => {
        const timeout = setTimeout( () => {                                       
            if (physicalRef.current  && isPhysicalCardVisible)
                physicalRef.current.click();
        }, 5200);

        return () => clearTimeout(timeout);
    }, [isPhysicalCardVisible]);

    const drawSolutionCardFromDeck = (cardType: CardType) => {
        playSound("/sounds/LightClick.mp3");

        if(!isUpdatingStatesDisabled)
        setIsUpdatingStatesDisabled(true);

        switch (cardType) {
            case "Emotional": {
                setIsEmotionalCardVisible(false);
                setClickedDeckStyle({ ...clickedDeckStyle, emotional: "disabled_clicked_deck" }); break;
            }
            case "Relations": {
                setIsSocialCardVisible(false);
                setClickedDeckStyle({ ...clickedDeckStyle, social: "disabled_clicked_deck" }); break;
            }
            case "Mental": {
                setIsMentalCardVisible(false);
                setClickedDeckStyle({ ...clickedDeckStyle, mental: "disabled_clicked_deck" }); break;
            }
            case "Physical": {
                setIsPhysicalCardVisible(false);
                setClickedDeckStyle({ ...clickedDeckStyle, physical: "disabled_clicked_deck" }); break;
            }
        }
    }

    return (
        <div className="initial_deck_wrapper">
            <div className="initial_deck center_horizontally_and_vertically">
                <img ref={emotionalRef} className={`initial_deck_card ${clickedDeckStyle.emotional}`} src={EmotionalDeck} alt="emotional" onClick={() => drawSolutionCardFromDeckLogic(CardType.EMOTIONAL_SOLUTION)} />
                <div className="initial_deck_card_type"> <span className="text_color_pink"> {t("emotionalText")} </span> {t("solutionsText")} </div>
            </div>
            <div className="initial_deck center_horizontally_and_vertically">
                <img ref={socialRef} className={`initial_deck_card ${clickedDeckStyle.social}`} src={SocialDeck} alt="social" onClick={() => drawSolutionCardFromDeckLogic(CardType.SOCIAL_SOLUTION)} />
                <div className="initial_deck_card_type"> <span className="text_color_yellow"> {t("socialText")} </span> {t("solutionsText")} </div>
            </div>
            <div className="initial_deck center_horizontally_and_vertically">
                <img ref={mentalRef} className={`initial_deck_card ${clickedDeckStyle.mental}`} src={MentalDeck} alt="mental" onClick={() => drawSolutionCardFromDeckLogic(CardType.MENTAL_SOLUTION)} />
                <div className="initial_deck_card_type"> <span className="text_color_blue"> {t("mentalText")} </span> {t("solutionsText")} </div>
            </div>
            <div className="initial_deck center_horizontally_and_vertically">
                <img ref={physicalRef} className={`initial_deck_card ${clickedDeckStyle.physical}`} src={PhysicalDeck} alt="physical" onClick={() => drawSolutionCardFromDeckLogic(CardType.PHYSICAL_SOLUTION)} />
                <div className="initial_deck_card_type"> <span className="text_color_green"> {t("physicalText")} </span> {t("solutionsText")} </div>
            </div>

        </div>
    )
}

export default InitialDeck;